import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

const JobDetailsModal = ({ show, onClose, job, onApply }) => {
    const [loading, setLoading] = useState(false);
    const [jobDetail, setJobDetail] = useState({});


    useEffect(() => {
        if (!job) return;

        fetch(`https://api.visko.group/api/crm/career/fetch-single-job?job_id=${job.c_id}`)
            .then((res) => res.json())
            .then((data) => {
                console.log(data, 333);
                setLoading(true);
                setJobDetail(data?.data || {});
            })
            .catch((error) => {
                console.error("Career API Error:", error);
                setLoading(false);
            });
    }, [job]);

    if (!job) return null;


    return (
        <Modal show={show} onHide={onClose} size="lg" centered scrollable>
            <Modal.Body style={{ padding: "24px" }}>

                {/* Header */}
                <div className="d-flex justify-content-between align-items-start mb-3">
                    <div>
                        <h5 className="fw-semibold">{job?.c_title}</h5>
                        <p className="text-muted mb-0">
                            {jobDetail.c_company_name}
                        </p>
                    </div>

                    <div className="d-flex gap-2 align-items-center">
                        <button
                            className="btn text-white px-3 py-1 rounded fs-6"
                            style={{
                                backgroundColor: "#ff6a32",
                            }}
                            onClick={onApply}
                        >
                            Apply Now
                        </button>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                        ></button>
                    </div>
                </div>

                {/* Meta Info */}
                <div className="d-flex gap-4 flex-wrap text-muted fs-6 border-bottom pb-3 mb-4">
                    <span><i className="bi bi-briefcase"></i> {jobDetail.c_experience}</span>
                    <span><i className="bi bi-geo-alt"></i> {jobDetail.c_location}</span>
                    <span><i className="bi bi-clock"></i> {jobDetail.c_job_type}</span>
                </div>

                {/* About Role */}
                <Section title="About The Role">
                    {jobDetail.c_about_role}
                </Section>

                {/* Key Responsibilities */}
                <Section title="Key Responsibilities">
                    <ul style={listStyle}>
                        {jobDetail?.c_key_responsibilities
                            ?.split(",")
                            .map((item, index) => (
                                <li key={index}>{item.trim()}</li>
                            ))}
                    </ul>
                </Section>


                {/* Required Skills */}
                <Section title="Required Skills">
                    {jobDetail?.c_required_skills
                        ?.split(",")
                        .map((skill, index) => (
                            <Tag key={index} text={skill.trim()} />
                        ))}
                </Section>



                {/* Good To Have */}
                <Section title="Good To Have">
                    {jobDetail?.c_good_to_have
                        ?.split(",")
                        .map((item, index) => (
                            <Tag key={index} light text={item.trim()} />
                        ))}
                </Section>

                {/* What We Offer */}
                <Section title="What We Offer">
                    <ul style={checkListStyle}>
                        {jobDetail?.c_what_we_offer
                            ?.split(",")
                            .map((offer, index) => (
                                <li key={index}>{offer.trim()}</li>
                            ))}
                    </ul>
                </Section>

                {/* Career Growth */}
                <div
                    style={{
                        background: "#f1f6ff",
                        borderRadius: "12px",
                        padding: "16px",
                        marginTop: "24px",
                    }}
                >
                    <h6 style={{ fontWeight: 600 }}>Career Growth At Visko</h6>
                    <p style={{ fontSize: "14px", color: "#4b5563" }}>
                        At Visko Group, we believe in nurturing talent and providing clear
                        career progression paths. Join us to unlock opportunities for
                        learning, development, and advancement within our growing
                        organization.
                    </p>
                </div>

                {/* Bottom Button */}
                <button
                    className="btn w-100 text-white mt-4"
                    style={{
                        backgroundColor: "#ff6a32",
                        borderRadius: "10px",
                        padding: "12px",
                    }}
                    onClick={onApply}
                >
                    Submit Application
                </button>
            </Modal.Body>
        </Modal>
    );
};

export default JobDetailsModal;

/* Helper Components */

const Section = ({ title, children }) => (
    <div style={{ marginBottom: "20px" }}>
        <h6 style={{ fontWeight: 600, marginBottom: "10px" }}>{title}</h6>
        <div style={{ fontSize: "14px", color: "#4b5563" }}>{children}</div>
    </div>
);

const Tag = ({ text, light }) => (
    <span
        style={{
            display: "inline-block",
            padding: "6px 12px",
            borderRadius: "999px",
            fontSize: "12px",
            marginRight: "8px",
            marginBottom: "8px",
            background: light ? "#f3f4f6" : "#eef2ff",
            color: light ? "#374151" : "#4338ca",
        }}
    >
        {text}
    </span>
);

const listStyle = {
    paddingLeft: "18px",
};

const checkListStyle = {
    paddingLeft: "18px",
    listStyleType: "✔  ",
};